import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Button, CloseIcon, Wysiwyg } from '../../../components';
import { ButtonColor, ButtonShape, ButtonSize, ButtonType, ButtonVariant, RenderType, } from '../../../enums';
import { useTimeoutSubscription } from '../../../hooks';
import stylesExpanded from './ProductTileExpandedArea.module.scss';
const ProductTileExpandedArea = ({ a11yPdpRedirectLabel, className, hasCartButton = false, isPortraitTile, name = '', services, setShowServices, showServices, url = '', }) => {
    const { a11yCloseServicesLabel, body, onCloseServices, onServicesActionButtonClick, servicesActionButtonLabel, } = services;
    const { cancelTimeout, timeoutIdRef } = useTimeoutSubscription();
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const handleServicesClosureClick = (event) => {
        onCloseServices(event);
        setShowServices(false);
    };
    useEffect(() => {
        if (showServices && !isServicesOpen) {
            setIsServicesOpen(true);
        }
        else if (!showServices && isServicesOpen) {
            timeoutIdRef.current = setTimeout(() => {
                setIsServicesOpen(false);
            }, 400);
        }
        return cancelTimeout;
    }, [cancelTimeout, isServicesOpen, showServices, timeoutIdRef]);
    return (_jsx(_Fragment, { children: services && isServicesOpen && (_jsx("div", { className: classNames(className, 'd-flex flex-column justify-content-start'), children: _jsx("div", { className: classNames(stylesExpanded.container, 'd-sm-flex overflow-hidden', {
                    [stylesExpanded.expandedDesktop]: showServices,
                    [stylesExpanded.isPortraitTile]: isPortraitTile,
                    [stylesExpanded.withCartButton]: hasCartButton,
                }), children: _jsxs("div", { className: classNames('d-flex flex-column h-100 w-100 flex-start', stylesExpanded.innerContainer), children: [_jsx(Button, { shape: ButtonShape.Icon, variant: ButtonVariant.Ghost, type: ButtonType.Button, color: ButtonColor.Grey, className: classNames(stylesExpanded.expandedCloseButton, 'p-2x', {
                                'd-none d-xs-flex ': !isPortraitTile,
                                'd-flex': isPortraitTile,
                            }), onClick: handleServicesClosureClick, a11yText: a11yCloseServicesLabel, children: _jsx(CloseIcon, {}) }), _jsx("p", { className: classNames(stylesExpanded.productName), children: name }), _jsx(Wysiwyg, { className: classNames('position-relative', stylesExpanded.expandedContent, servicesActionButtonLabel
                                ? [
                                    stylesExpanded.contentWithActionButton,
                                    'mb-xs-1x overflow-hidden',
                                ]
                                : stylesExpanded.contentWithoutActionButton), content: body }), servicesActionButtonLabel && (_jsxs(Button, { as: RenderType.Link, href: url, variant: hasCartButton
                                ? ButtonVariant.Outlined
                                : ButtonVariant.Contained, color: ButtonColor.Brand, className: classNames('w-100', {
                                'mb-xs-2x': hasCartButton,
                                'mb-xs-3x': !hasCartButton,
                            }), onClick: onServicesActionButtonClick, size: ButtonSize.ResponsiveXs, a11yText: a11yPdpRedirectLabel, children: [servicesActionButtonLabel, _jsx("span", { className: "screenReaderOnly", children: a11yPdpRedirectLabel })] }))] }) }) })) }));
};
export { ProductTileExpandedArea };
